

import axiosInstance from '../../config';

export const  closeAllPositionService =async(token )=>{

    try{
        const response = await axiosInstance.get(`/v2/exitAllPosition/${token}`,
            {
                headers:{Authorization: `Bearer ${token}`}
            }
        )

  

        return{
            success:true,
            data:response.data,
            status:response.status,

        }
    }

    catch(error){

         console.log("error", error.response)
          return {
            success: false,
            
            message: error.response?.data?.message || "Alert Send failed",
            status: error.response?.status || 500,
            errors: error.response?.data?.data || null,
        };



    }



} 